import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-form-validation-sample',
  templateUrl: './form-validation-sample.component.html',
  styleUrls: ['./form-validation-sample.component.css']
})
export class FormValidationSampleComponent implements OnInit {

  @ViewChild('myForm')
  private myForm: NgForm;

  private count: number = 1;

  phoneNumberIds: number[] = [1];

  remove(i: number) {
    this.phoneNumberIds.splice(i, 1);
  }

  add() {
    this.phoneNumberIds.push(++this.count);
  }

  register(myForm: NgForm) {
    console.log('Successful registration');
    console.log(myForm);
  }

  constructor() { }

  ngOnInit() {
  }

  getTitle(): string {
    return "form validation sample";
  }
}



// WEBPACK FOOTER //
// ./src/app/test/form-validation-sample/form-validation-sample.component.ts